import {DragDropContext, Draggable, DraggingStyle, Droppable, DropResult, NotDraggingStyle,} from "react-beautiful-dnd";
import {toast} from "react-toastify";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {setControlDeliveriesAction} from "../../app/reducers/delivery-slice";
import {scheduleState} from "../../app/reducers/schedule-slice";
import {DeliveryGroupType} from "../../types/schedule/delivery-group-type";
import {PreviewDeliveryGroup} from "../../types/schedule/preview-delivery-group";
import {ScheduleDeliveryGroupCard} from "../card/ScheduleDeliveryGroupCard";

type DraggableStyle = DraggingStyle | NotDraggingStyle | undefined;

export const DraggablePreviewItemList = () => {
    const dispatch = useAppDispatch();
    const {preview} = useAppSelector(scheduleState);

    const reorder = (
        startIndex: number,
        endIndex: number,
        list: PreviewDeliveryGroup[]
    ) => {
        if (list[startIndex].isComplete || list[endIndex].isComplete) {
            toast.error("완료된 물류는 순서를 변경할 수 없습니다.");
            return;
        }

        if (list[startIndex].isWork) {
            if (list[startIndex].isPickUp && list[startIndex].isSomePickUp) {
                toast.error("작업중인 물류는 순서를 변경할 수 없습니다.");
                return;
            }
            if (list[startIndex].isDropOff && list[startIndex].isSomeDropOff) {
                toast.error("작업중인 물류는 순서를 변경할 수 없습니다.");
                return;
            }
        }

        if (list[endIndex].isWork) {
            if (list[endIndex].isPickUp && list[endIndex].isSomePickUp) {
                toast.error("작업중인 물류는 순서를 변경할 수 없습니다.");
                return;
            }
            if (list[endIndex].isDropOff && list[endIndex].isSomeDropOff) {
                toast.error("작업중인 물류는 순서를 변경할 수 없습니다.");
                return;
            }
        }

        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        const results = result.flatMap((deliveryGroup) => {
            return deliveryGroup.deliveriesInGroup.map((deliveryInGroup) => {
                return {
                    key: deliveryInGroup.id + deliveryGroup.type,
                    deliveryId: deliveryInGroup.id,
                    type: deliveryGroup.type,
                };
            });
        });

        for (const controlDelivery of results) {
            const sameIdDeliveries = results.filter(
                (result) => result.deliveryId === controlDelivery.deliveryId
            );
            if (sameIdDeliveries.length === 2) {
                if (sameIdDeliveries[1].type === DeliveryGroupType.PickUp) {
                    toast.error("상차 물류는 전달 물류보다 먼저 배치할 수 없습니다.");
                    return list;
                }
            }
        }

        dispatch(
            setControlDeliveriesAction({
                deliveryKeys: results.map((controlDelivery) => controlDelivery.key),
            })
        );
        return;
    };

    const onDragEnd = (result: DropResult) => {
        if (!result.destination) {
            return;
        }

        reorder(result.source.index, result.destination.index, preview);
    };

    const getItemStyle = (
        isDragging: boolean,
        draggableStyle: DraggableStyle
    ): React.CSSProperties => ({
        filter: `${
            isDragging
                ? "drop-shadow(0px 30px 30px rgba(0, 0, 0, 0.1))"
                : "drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.1))"
        }`,
        ...draggableStyle,
    });
    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable
                droppableId="deliveryGroup-card-draggable"
                direction="vertical"
            >
                {(provided, snapshot) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                        {preview.map((deliveryGroup, index) => {
                            const draggableKey =
                                deliveryGroup.startTimeLimited +
                                deliveryGroup.type +
                                deliveryGroup.location.id +
                                index;

                            return (
                                <Draggable
                                    key={draggableKey}
                                    draggableId={`control-delivery-draggable-${draggableKey}`}
                                    index={index}
                                >
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps.style
                                            )}
                                        >
                                            <ScheduleDeliveryGroupCard
                                                deliveryGroup={deliveryGroup}
                                                index={index}
                                            />
                                        </div>
                                    )}
                                </Draggable>
                            );
                        })}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
};
